export default
    [
        {
            id: 0,
            title: "Introduction",
            subtitle: "On sustainable printing and why it matters?",
            img: "post-0.png",
            author: 'Lena Mitkowa',
            postDate: 'summer 2020'
        },
        {
            id: 1,
            title: "Chapter one",
            subtitle: "In which we think about what we actually need.",
            img: "post-1.png",
            author: 'Lena Mitkowa',
            postDate: 'summer 2020'
        },
        {
            id: 2,
            title: "Chapter two",
            subtitle: "In which we decide on the print run.",
            img: "post-2.png",
            author: 'Lena Mitkowa',
            postDate: 'summer 2020'
        },
        {
            id: 3,
            title: "Chapter three",
            subtitle: "In which we choose the right paper.",
            img: "post-3.png",
            author: 'Lena Mitkowa',
            postDate: 'summer 2020'
        },
        {
            id: 4,
            title: "Chapter four",
            subtitle: "In which we cut back on razzle-dazzle.",
            img: "post-4.png",
            author: 'Lena Mitkowa',
            postDate: 'summer 2020'
        },
        {
            id: 5,
            title: "Chapter five",
            subtitle: "In which we print locally.",
            img: "post-5.png",
            author: 'Lena Mitkowa',
            postDate: 'summer 2020'
        },
        {
            id: 6,
            title: "Chapter six",
            subtitle: "In which we share our knowledge.",
            img: "post-6.png",
            author: 'Lena Mitkowa',
            postDate: 'summer 2020'
        }
    ]
